(() => {
  const header = document.querySelector('[data-site-header]');
  if (!header) return;

  const drawer = header.querySelector('[data-mobile-nav]');
  const openButton = header.querySelector('[data-mobile-nav-open]');
  const closeButtons = header.querySelectorAll('[data-mobile-nav-close]');

  const openDrawer = () => {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    openButton?.setAttribute('aria-expanded', 'true');
    document.body.classList.add('mobile-nav-open');
    drawer.querySelector('.mobile-drawer__head button')?.focus();
  };

  const closeDrawer = () => {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    openButton?.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('mobile-nav-open');
  };

  openButton?.addEventListener('click', openDrawer);
  closeButtons.forEach((button) => button.addEventListener('click', closeDrawer));

  drawer?.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', closeDrawer);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawer?.classList.contains('is-open')) {
      closeDrawer();
      openButton?.focus();
    }
  });

  const closeDesktopMenus = (except) => {
    header.querySelectorAll('.site-header__nav-item[open]').forEach((item) => {
      if (item !== except) item.removeAttribute('open');
    });
  };

  const desktopHover = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
  header.querySelectorAll('.site-header__nav-item').forEach((item) => {
    let closeTimer;
    item.addEventListener('pointerenter', (event) => {
      if (!desktopHover.matches || event.pointerType !== 'mouse') return;
      clearTimeout(closeTimer);
      closeDesktopMenus(item);
      item.open = true;
    });
    item.addEventListener('pointerleave', (event) => {
      if (!desktopHover.matches || event.pointerType !== 'mouse') return;
      clearTimeout(closeTimer);
      closeTimer = setTimeout(() => {
        if (!item.contains(document.activeElement)) item.open = false;
      }, 180);
    });
    item.addEventListener('focusout', () => {
      setTimeout(() => {
        if (!item.contains(document.activeElement) && !item.matches(':hover')) item.open = false;
      }, 0);
    });
    item.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      clearTimeout(closeTimer);
      item.open = false;
      item.querySelector('summary')?.focus();
      event.stopPropagation();
    });
    item.addEventListener('toggle', () => {
      if (item.open) closeDesktopMenus(item);
    });
  });

  document.addEventListener('click', (event) => {
    if (!header.contains(event.target)) closeDesktopMenus();
  });
})();

